import React from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { ApplicationState } from '../../store';
import { Redirect } from 'react-router-dom';
import { createDebtorIdsQueryString } from '../Utils';

interface PropsFromState {
  selectedCaseNumber?: string | null;
  debtorId?: string | null;
}

type ComponentProps = PropsFromState;

class RedirectSingleClaimView extends React.Component<ComponentProps> {

  public render() {
    
    if (this.props.selectedCaseNumber !== null) {
      const debtorUrl = `/claims?${createDebtorIdsQueryString([this.props.debtorId!])}&caseNumber=${this.props.selectedCaseNumber}`;
      return (
        <Redirect to={debtorUrl} />
      );
    }
    else {
      return (
        <Redirect to={'/search'} />
      );
    }
  }
}

const mapStateToProps = ({ debtorSearch }: ApplicationState): PropsFromState => ({
  selectedCaseNumber: debtorSearch.selectedCaseNumber,
  debtorId: debtorSearch.selectedResult!.document!.relatedDebtorIds![0]
});

export default compose(
  connect(mapStateToProps)
)(RedirectSingleClaimView);
